export const QA_PLATFORM_ADMIN = 'Qa-Platform-Admin';
export const QA_PLATFORM_DEVELOPER = 'Qa-Platform-Developer';
export const QA_PLATFORM_BETA = 'Qa-Platform-Beta';
export const QA_PLATFORM_ACCESS = 'Qa-Platform-Access';
